import React from "react";
import { useSelector } from "react-redux";
import FieldTime from "@default/general-components/date-time/field-time";
import DateWrapper from "@default/js/participants/components/date-wrapper";
import { FormattedMessage, useIntl } from "react-intl";
import FestivalDay from "@default/general-components/date-time/festival-day";
import appearancesInPast from "@default/lib/appearances-in-past";
import IconTime from "@default/general-components/icon-time";
import IconLocation from "@default/general-components/icon-location";

const AppearanceDetailed = ({
  appearance,
  type,
  showAddToCalendar,
  viewMode,
  forceLongDayName,
  showEndDate,
}) => {
  const releaseState = useSelector(
    (reduxStore) => reduxStore.appStore.releaseState
  );

  if (!appearance.fieldPlanned) {
    forceLongDayName = true;
  }

  const intl = useIntl();
  const shortDayFormat = intl.formatMessage({ id: "date.short_day_format" });
  const longDayFormat = intl.formatMessage({ id: "date.long_day_format" });

  if (appearance?.fieldDateRawField?.first?.value) {
    return (
      <article className="appearance simple">
        <div className="row">
          <div className="time">
            <IconTime />
            <div className="day body-m make-headline-light">
              {releaseState.showDay &&
              appearance?.fieldDateRawField?.first?.value ? (
                <FieldTime
                  timestamp={true}
                  date={appearance.fieldDateRawField?.first?.value}
                  format={
                    !releaseState.showDate || forceLongDayName
                      ? longDayFormat
                      : shortDayFormat
                  }
                  dependsOnReleaseState={true}
                />
              ) : (
                <>TBA</>
              )}
            </div>
            <DateWrapper
              content={appearance}
              viewMode={"time"}
              showEndDate={showEndDate}
              className="time body-m"
            />
          </div>
          <div className="venue d-flex flex-row icon-flex-wrap make-headline">
            <span className="venue-name body-m make-headline">
              <IconLocation />
              {appearance.fieldVenueLocation && releaseState.showDate ? (
                <>{appearance.fieldVenueLocation.label}</>
              ) : (
                <>TBA</>
              )}
            </span>
          </div>
        </div>
        {releaseState.showDay && !appearance?.fieldFake && (
          <div className="row">
            <div className="festival-day body-m">
              <FestivalDay
                appearance={appearance}
                dependsOnReleaseState={true}
              />
            </div>
          </div>
        )}
      </article>
    );
  }
};

export default AppearanceDetailed;
